import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  paper: {
    width: '100%',
    maxWidth: '29.75rem',
  },
}));
